import { render, staticRenderFns } from "./layout-exterior.vue?vue&type=template&id=406be1d8"
import script from "./layout-exterior.vue?vue&type=script&lang=js"
export * from "./layout-exterior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports